let database;
if (process.env.VUE_APP_IS_BROWSER)
  database = require('./client-database.js');
else database = require('./server-database.js');

module.exports = database;
